import type { CalendarDay } from "@learn-flow/contracts";

import { formatFullDate, formatMinutes } from "../calendar/calendar-date.js";

export function calendarDayAccessibleName(day: CalendarDay): string {
  const date = formatFullDate(day.date);
  if (day.sessions.length === 0) return `${date}, open day, no activity planned`;
  const sessionLabel = day.sessions.length === 1 ? "1 session" : `${day.sessions.length} sessions`;
  return `${date}, ${sessionLabel}, ${formatMinutes(
    day.totalActivityDurationMinutes,
  )} of activity time`;
}
